import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addMaterials = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_material',
    '/api/resource/Material',
    body
  );
  return data;
});
export const updateMaterials = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Material/${id}`,
    body
  );
  return data;
});

export const deleteMaterials = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`/api/resource/Material/${id}`);
  return data;
});

export const getMaterials = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_materials'
  );
  return data;
});
export const getMaterialsDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Material/${id}`);
  return data;
});
